import { SERVICES } from "./onboarding";
import compact from "lodash/compact";
import { MOCK_UUID } from "./constants/request";
import { getConfig } from "./env";

const PATHS = {
  // --- Authenticated ---
  HUB: "/hub",
  HUB_APPLICATIONS_SHOW: "/hub/applications/[application-uuid]",
  /**
   * App Hub Sections
   */
  HUB_APPLICATIONS_HOME: "/hub/applications/[application-uuid]/home",
  HUB_APPLICATIONS_ANALYTICS: "/hub/applications/[application-uuid]/analytics",
  HUB_APPLICATIONS_PAGES: "/hub/applications/[application-uuid]/pages",
  HUB_APPLICATIONS_SETTINGS: "/hub/applications/[application-uuid]/settings",
  /**
   * App Hub Products
   */
  HUB_APPLICATIONS_PRODUCTS: "/hub/applications/[application-uuid]/products",
  HUB_APPLICATIONS_PRODUCTS_SHOW:
    "/hub/applications/[application-uuid]/products/[product-uuid]",
  HUB_APPLICATIONS_PRODUCTS_PRICES_SHOW:
    "/hub/applications/[application-uuid]/products/[product-uuid]/prices/[price-uuid]",
  HUB_APPLICATIONS_PRODUCTS_LINKS_SHOW:
    "/hub/applications/[application-uuid]/products/[product-uuid]/links/[short-link-uuid]",
  /**
   * App Hub Short Links
   */
  HUB_APPLICATIONS_LINKS: "/hub/applications/[application-uuid]/links",
  HUB_APPLICATIONS_LINKS_CREATE:
    "/hub/applications/[application-uuid]/links/create",
  HUB_APPLICATIONS_LINKS_SHOW:
    "/hub/applications/[application-uuid]/links/[short-link-uuid]",
  /**
   * App Hub Coupons
   */
  HUB_APPLICATIONS_COUPONS: "/hub/applications/[application-uuid]/coupons",
  HUB_APPLICATIONS_COUPONS_SHOW:
    "/hub/applications/[application-uuid]/coupons/[coupon-uuid]",
  /**
   * App Hub Tax Rates
   */
  HUB_APPLICATIONS_TAX_RATES: "/hub/applications/[application-uuid]/tax-rates",
  HUB_APPLICATIONS_TAX_RATES_SHOW:
    "/hub/applications/[application-uuid]/tax-rates/[tax-rate-uuid]",
  /**
   * App Hub Attachments
   */
  HUB_APPLICATIONS_FILES: "/hub/applications/[application-uuid]/files",
  HUB_APPLICATIONS_FILES_SHOW:
    "/hub/applications/[application-uuid]/files/[attachment-uuid]",
  /**
   * App Hub datasources
   */
  HUB_APPLICATIONS_DATASOURCES:
    "/hub/applications/[application-uuid]/datasources",
  HUB_APPLICATIONS_DATASOURCES_SHOW:
    "/hub/applications/[application-uuid]/datasources/[datasource-uuid]",

  /**
   * App Hub Campaigns
   */
  HUB_APPLICATIONS_CAMPAIGNS: "/hub/applications/[application-uuid]/campaigns",
  HUB_APPLICATIONS_CAMPAIGNS_BUILDER:
    "/hub/applications/[application-uuid]/campaigns/builder",
  HUB_APPLICATIONS_CAMPAIGNS_SHOW:
    "/hub/applications/[application-uuid]/campaigns/[campaign-uuid]",
  /**
   * App Hub Sales
   */
  HUB_APPLICATIONS_SALES: "/hub/applications/[application-uuid]/sales",
  HUB_APPLICATIONS_SALES_SHOW:
    "/hub/applications/[application-uuid]/sales/[sale-uuid]",

  /**
   * Features
   */
  FEATURES_PAGES: "/features/pages",
  FEATURES_CHANNELS: "/features/channels",
  FEATURES_LINKS: "/features/links",
  FEATURES_LINKS_BUILDER: "/features/links/builder",
  FEATURES_LINKS_BUILDER_SHOW: "/features/links/builder/[short-id]",

  /**
   * Docs
   */
  DOCS: "/docs",
  DOCS_INTRODUCTION: "/docs/introduction/[slug]",

  /**
   * Tutorials
   */
  TUTORIALS: "/tutorials",
  TUTORIALS_SHOW: "/[slug]",
  TUTORIALS_EMAIL_SHOW: "/email/[slug]",

  /**
   * Learn
   */
  LEARN: "/docs",
  LEARN_SHOW: "/[slug]",
  LEARN_EMAIL_SHOW: "/email/[slug]",

  ONBOARDING: "/onboarding",
  MARKETPLACE: "/marketplace",
  TEAM: "/team",
  QUIZ: "/quiz",
  EVALUATE: "/evaluate",
  COMPARE: "/compare",
  GOALS: "/goals",
  PLAN: "/plan",
  PROFILE: "/profile",
  PRICING: "/pricing",
  SUPPORT: "/support",
  CHECKOUT: "/checkout",
  CHECKOUT_SUCCESS: "/checkout/success",
  CHECKOUT_CONTENT: "/checkout/content",
  CHECKOUT_ERROR: "/checkout/error",
  SECRET_TEST: "/secret-test",
  // --- PAGES ---
  PAGES: "/pages",
  // --- LINKS ---
  LINKS_SHOW: "/links/[short-id]",
  // --- APPLICATIONS ---
  APPLICATIONS: "/applications",
  APPLICATIONS_SHOW: "/applications/[application-uuid]",
  APPLICATIONS_TEMPLATES: "/applications/[application-uuid]/templates",
  APPLICATIONS_PAGES: "/applications/[application-uuid]/pages",
  APPLICATIONS_PAGES_NEW: "/applications/[application-uuid]/pages/new",
  APPLICATIONS_PAGES_SHOW: "/applications/[application-uuid]/pages/[page-uuid]",
  APPLICATIONS_PAGES_SHOW_SECTION:
    "/applications/[application-uuid]/pages/[page-uuid]/[section-uuid]",
  OAUTH: "/oauth",
  // --- Authentication ---
  LOGIN: "/login",
  SIGNUP: "/signup",
  RESET: "/reset",
  RESET_CONFIRM: "/reset-confirm",
  EXCHANGE: "/exchange",
  EXCHANGE_STRIPE: "/exchange/stripe",
  OAUTH_INITIATE_SERVICE: "/oauth/[service]/initiate",
  EXCHANGE_INTEGRATIONS_SERVICE: "/exchange/integrations/[service]",
  // --- Legal ---
  PRIVACY: "/privacy",
  TERMS: "/terms",
  COOKIE_POLICY: "/cookie-policy",
  // --- General ---
  ERROR: "/error",
  RUNTIME: "/runtime",
  // --- Marketing Pages ---
  HOME: "/",
  LEVELS_EXPLAINED: "/levels-explained",
  EVALUATIONS_EXPLAINED: "/evaluations-explained",
  GOALS_EXPLAINED: "/goals-explained",
  PRODUCTS_EXPLAINED: "/products-explained",
  TEAM_EXPLAINED: "/team-explained",
  // --- Guest Pages ---
  GUEST_EVALUATE: "/guest-evaluate",
  GUEST_COMPARE: "/guest-compare",
  /**
   * Test routes
   */
  TEST_LINKS_SHOW: "/test/links/[short-id]",
  TEST_CHECKOUT_SUCCESS: "/test/checkout/success",
  TEST_CHECKOUT_CONTENT: "/test/checkout/content",
  TEST_CHECKOUT_ERROR: "/test/checkout/error"
};

export const SUBDOMAIN_ROUTES = [
  PATHS.PRICING,
  PATHS.CHECKOUT,
  PATHS.CHECKOUT_SUCCESS,
  PATHS.CHECKOUT_CONTENT,
  PATHS.CHECKOUT_ERROR,
  PATHS.TEST_CHECKOUT_SUCCESS,
  PATHS.TEST_CHECKOUT_CONTENT,
  PATHS.TEST_CHECKOUT_ERROR
];

export const UNAUTHED_ROUTES = [
  PATHS.HOME,
  PATHS.LOGIN,
  PATHS.SECRET_TEST,
  PATHS.MARKETPLACE,
  PATHS.GUEST_EVALUATE,
  PATHS.GUEST_COMPARE,
  PATHS.GUESTS_BUILDER,
  PATHS.GOALS,
  PATHS.SIGNUP,
  PATHS.OAUTH,
  PATHS.SUPPORT,
  PATHS.RESET,
  PATHS.ERROR,
  PATHS.RESET_CONFIRM,
  PATHS.PRIVACY,
  PATHS.COOKIE_POLICY,
  PATHS.TERMS,
  PATHS.LEVELS_EXPLAINED,
  PATHS.GOALS_EXPLAINED,
  PATHS.PRODUCTS_EXPLAINED,
  PATHS.TEAM_EXPLAINED,
  PATHS.EVALUATIONS_EXPLAINED,
  PATHS.RUNTIME,
  PATHS.EXCHANGE,
  PATHS.LINKS_SHOW,
  PATHS.TEST_LINKS_SHOW,
  PATHS.FEATURES_PAGES,
  PATHS.FEATURES_CHANNELS,
  PATHS.FEATURES_LINKS,
  PATHS.FEATURES_LINKS_BUILDER,
  PATHS.FEATURES_LINKS_BUILDER_SHOW,
  PATHS.LEARN,
  PATHS.LEARN_SHOW,
  PATHS.LEARN_EMAIL_SHOW,
  ...SUBDOMAIN_ROUTES
];

export const AUTHED_REDIRECT_ROUTES = [PATHS.EXCHANGE_STRIPE];
export const NAV_HIDE_ROUTES = [
  PATHS.APPLICATIONS_PAGES_SHOW,
  PATHS.APPLICATIONS_PAGES_SHOW_SECTION
];

export const OAUTH_ROUTES = {
  GOOGLE: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/auth/google/identity/web`,
  SLACK: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/auth/slack/identity/web`,
  SHOPIFY: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/auth/shopify/identity/web`,
  SQUARESPACE: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/auth/squarespace/identity/web`,
  SLACK_BOT: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/auth/slack/bot/web`
};

export const THIRD_PARTY_SCRIPTS = {
  RECAPTCHA: "https://www.google.com/recaptcha/api.js"
};

export const EXTERNAL = {
  DATACLIPS: `https://data.heroku.com/dataclips`,
  STRIPE: `https://dashboard.stripe.com`
};

export const BUILD_EXTERNAL = {
  [SERVICES.SQUARESPACE]: {
    API_KEYS: (shop) =>
      `https://${shop}.squarespace.com/config/settings/advanced/developer-api-keys`
  }
};

export const API_PATHS = {
  CHECKOUT: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/stripe/checkout`,
  LINKS: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/links`,
  DOCS: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/docs`,
  DOCS_PREVIEW: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/docs/preview`,
  /**
   * Checkout Success
   */
  CHECKOUT_SUCCESS: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/stripe/checkout/success`,
  TEST_CHECKOUT_SUCCESS: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/test/stripe/checkout/success`,
  CHECKOUT_SUCCESS_PREVIEW: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/stripe/checkout/success/preview`,
  /**
   * Checkout Error
   */
  CHECKOUT_ERROR: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/stripe/checkout/error`,
  /**
   * Checkout Content
   */
  CHECKOUT_CONTENT: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/stripe/checkout/content`,
  TEST_CHECKOUT_CONTENT: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/test/stripe/checkout/content`,
  /**
   * Sessions
   */
  CHECKOUT_SESSION: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/checkout/sessions`,
  BILLING_SESSION: `${process.env.NEXT_PUBLIC_API_ROOT}/v1/billing/sessions`
};

export const ASSET_PATHS = {
  STRIPE: `https://files.stripe.com/links`
};

export const HIDE_PLATFORM_SCRIPT_PATHS = [
  PATHS.LINKS_SHOW,
  PATHS.TEST_LINKS_SHOW
];

export const apiResourcePath = ({ resource, resourceUUID, test }) =>
  compact([
    `${process.env.NEXT_PUBLIC_API_ROOT}/v1`,
    test || resourceUUID === MOCK_UUID ? "test" : "",
    `${resource}s/${resourceUUID}`
  ]).join("/");

export default PATHS;

export const DOCS_PATHS = {
  PAYMENT_LINK: {
    PAYMENT_METHODS_RESTRICTIONS: `${getConfig("WEB_CLIENT_ROOT")}${
      PATHS.LEARN
    }/payment-links/payment-methods#restrictions`,
    PAYMENT_DETAILS_RESTRICTIONS: `${getConfig("WEB_CLIENT_ROOT")}${
      PATHS.LEARN
    }/payment-links/payment-details#restrictions`
  }
};
